import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import {
  type GroupNode,
  NgDiagramGroupHighlightedDirective,
  type NgDiagramGroupNodeTemplate,
  NgDiagramNodeResizeAdornmentComponent,
  NgDiagramNodeSelectedDirective,
  NgDiagramPortComponent,
} from 'ng-diagram'
import { DdcCountryFlagComponent } from 'src/app/shared/ddc/ddc-country-flag/ddc-country-flag.component'
import { DaydicTypesIconNames } from 'src/app/shared/enums/enums'
import { Pair } from 'src/app/shared/models/main/pair'

export interface GroupNodeData {
  pair: Pair
}

@Component({
  selector: 'ddc-canvas-node-pair',
  imports: [
    NgDiagramPortComponent,
    NgDiagramNodeSelectedDirective,
    NgDiagramGroupHighlightedDirective,
    CommonModule,
    NgDiagramNodeResizeAdornmentComponent,
    MatIcon,
    DdcCountryFlagComponent,
  ],
  templateUrl: './pair-node.component.html',
  styleUrls: ['./pair-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.ng-diagram-port-hoverable]': 'true',
  },
})
export class CanvasPairNodeComponent implements NgDiagramGroupNodeTemplate<GroupNodeData> {
  node = input.required<GroupNode<GroupNodeData>>()
  title = signal<string>('Pair')
  icon = signal<string>(DaydicTypesIconNames.PAIR)
}
